import { Popconfirm } from 'antd';
import { useRouter } from 'next/navigation';
import React from 'react';
export const GoBackButton: React.FC<{
  disabled?: boolean;
  popConfirm?: boolean;
  title?: string;
}> = ({ disabled = false, popConfirm = false, title }) => {
  const router = useRouter();

  if (popConfirm) {
    return (
      <Popconfirm
        disabled={disabled}
        placement="topLeft"
        okButtonProps={{ style: { backgroundColor: 'blue' } }}
        title={title}
        description={
          <p className="max-w-[160px]">
            Are you sure? Exiting this page will make you lose any unsaved
            changes.
          </p>
        }
        okText="Yes"
        cancelText="No"
        onConfirm={() => router.back()}
      >
        <button
          type="button"
          disabled={disabled}
          className="goBackButton flex items-center text-gray-600 hover:text-gray-900"
        >
          <svg
            className="w-5 h-5 mr-2"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M10 19l-7-7m0 0l7-7m-7 7h18"
            />
          </svg>
          Back
        </button>
      </Popconfirm>
    );
  }
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={() => router.back()}
      className="goBackButton flex items-center text-gray-600 hover:text-gray-900"
    >
      <svg
        className="w-5 h-5 mr-2"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M10 19l-7-7m0 0l7-7m-7 7h18"
        />
      </svg>
      Back
    </button>
  );
};
